//import Menu from '../../data/menu';
//import Menu2 from '../../data/menu2';
import decode from 'jwt-decode';

const token = localStorage.getItem('token');
let Menu = [];
let usuarioDB = [];

if (token !== null) {
  usuarioDB = decode(token);

  switch (Number(usuarioDB.id_rol)) {
    case 2:
      Menu.data = [
        {
          "title": "ANALISTA", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "5", "active": true,
          "children": [
            { "path": "/analista/buscarPersona", "title": "Lista de Registros", "type": "link" },
            { "path": "/analista/frmPersona", "title": "Nuevo Registro", "type": "link" },
            { "path": "/analista/buscarEmpresas", "title": "Empresas", "type": "link" },
            { "path": "/analista/buscarPersonaEmpresa", "title": "Buscar Usuario Empresa", "type": "link" },
            { "path": "/analista/buscarExtranjero", "title": "Buscar Extranjero", "type": "link" },
            { "path": "/analista/buscarExtranjeroSicof", "title": "Buscar Extranjero Sicof", "type": "link" },
            { "path": "/analista/analisisSeguimiento", "title": "Análisis y Seguimiento", "type": "link" }
          ]
        }
      ];
      break;
    case 3:
      Menu.data = [
        {
          "title": "EMPRESA", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "2", "active": true,
          "children": [
            { "path": "/empresa/Empresas", "title": "Empresa", "type": "link" },
            // { "path": "/empresa/ReporteTotalEmpresa", "title": "Reportes por Empresa", "type": "link" },
            { "path": "/empresa/Reportes", "title": "Reportes", "type": "link" }
          ]
        }
      ];
      break;
    case 4:
      Menu.data = [
        {
          "title": "PERSONA", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "2", "active": true,
          "children": [
            { "path": "/extranjero/historialdeclaracion", "title": "Historial de Declaración", "type": "link" },
            { "path": "/extranjero/declaracion", "title": "Declaración", "type": "link" },
            //{ "path": "/extranjero/DeclaracionHijos", "title": "Declaración Menores", "type": "link" }
          ]
        }
      ];
      break;
    case 5:
      Menu.data = [
        {
          "title": "OPERADOR", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "4", "active": true,
          "children": [
            { "path": "/analista/buscarPersona", "title": "Lista de Registros", "type": "link" },
            { "path": "/analista/frmPersona", "title": "Nuevo Registro", "type": "link" },
           { "path": "/analista/ReporteDiario", "title": "Parte Diario", "type": "link" },
            { "path": "/analista/ReportePorOperador", "title": "Reporte", "type": "link" }
          ]
        }
      ];
      break;
    // case 6:
    //   Menu.data = [
    //     {
    //       "title": "AUTOMATIZADO", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "1", "active": true,
    //       "children": [
    //         { "path": "/automatizado/Vuelos", "title": "Vuelos", "type": "link" },
    //         { "path": "/automatizado/listaRobot", "title": "Listado", "type": "link" },
    //         { "path": "/robot/FormularioError", "title": "Formulario Robot", "type": "link" },
    //         { "path": "/robot/reporteRobot", "title": "Reportes Robot", "type": "link" },
    //         /*{ "path": "/automatizado/Equipos", "title": "Equipos", "type": "link" },
    //         { "path": "/automatizado/ReporteVuelos", "title": "Reportes", "type": "link" }*/
    //       ]
    //     }
    //   ];
    //   break;
    case 7:
      Menu.data = [
        {
          "title": "REPORTES", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "3", "active": true,
          "children": [
            { "path": "/reporte/reporteEmpresa", "title": "Reporte de Empresas", "type": "link" },
            { "path": "/reporte/reporteAereo", "title": "Reporte Aereo", "type": "link" },
            { "path": "/reporte/reporteHotel", "title": "Reporte Hotel", "type": "link" }
          ]
        }
      ];
      break;
      case 8:
      Menu.data = [
        {
          "title": "OPERADOR VENT.", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "1", "active": true,
          "children": [
            //{ "path": "/ventanilla/analisisSeguimientoVentanilla", "title": "Personas Multadas", "type": "link" }
            { "path": "/analista/buscarPersona", "title": "Lista de Registros", "type": "link" },
            { "path": "/analista/frmPersona", "title": "Nuevo Registro", "type": "link" },
            { "path": "/analista/ReporteDiario", "title": "Parte Diario", "type": "link" },
            { "path": "/analista/ReportePorOperador", "title": "Reporte", "type": "link" }
          ]
        }
      ];
      break;
      case 11:
      Menu.data = [
        {
          "title": "VERIFICACIÓN", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "1", "active": true,
          "children": [
            //{ "path": "/ventanilla/analisisSeguimientoVentanilla", "title": "Personas Multadas", "type": "link" }
            { "path": "/verificacion/Verificar", "title": "Busqueda de Trámites", "type": "link"},
            
          ]
        }
      ];
      break;
    default:
      Menu.data = []
      break;
  }

}

const state = {
  data: Menu.data,
  searchData: [],
  togglesidebar: true
}

// getters
const getters = {

}

// mutations
const mutations = {
  opensidebar: (state) => {
    state.togglesidebar = !state.togglesidebar
  },
  resizetoggle: (state) => {
    if (window.innerWidth < 1199) {
      state.togglesidebar = false
    } else {
      state.togglesidebar = true
    }
  },
  searchTerm: (state, term) => {
    let items = [];
    var searchval = term.toLowerCase();
    state.data.filter(menuItems => {
      if (menuItems.title) {
        if (menuItems.title.toLowerCase().includes(searchval) && menuItems.type === 'link') {
          items.push(menuItems);
        }
        if (!menuItems.children) return false
        menuItems.children.filter(subItems => {
          if (subItems.title.toLowerCase().includes(searchval) && subItems.type === 'link') {
            subItems.icon = menuItems.icon
            items.push(subItems);
          }
          if (!subItems.children) return false
          subItems.children.filter(suSubItems => {
            if (suSubItems.title.toLowerCase().includes(searchval)) {
              suSubItems.icon = menuItems.icon
              items.push(suSubItems);
            }
          })
        })
        state.searchData = items
      }
    });
  },
  setNavActive: (state, item) => {

    if (!item.active) {
      state.data.forEach(a => {
        if (state.data.includes(item))
          a.active = false
        if (!a.children) return false
        a.children.forEach(b => {
          //console.log(b);
          if (a.children.includes(item)) {
            b.active = false
          }
        })
      });
    }

    item.active = !item.active
  },
  setActiveRoute: (state, item) => {

    state.data.filter(menuItem => {
      if (menuItem != item)
        menuItem.active = false
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true
            submenuItems.active = true
          }
        })
      }
    })
  },
  generarMenu: (state, payload) => {

    if (payload !== null) {
      usuarioDB = decode(payload);

      switch (Number(usuarioDB.id_rol)) {
        case 2:
          state.data = [
            {
              "title": "ANALISTA", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "5", "active": true,
              "children": [
                { "path": "/analista/buscarPersona", "title": "Lista de Registros", "type": "link" },
                { "path": "/analista/frmPersona", "title": "Nuevo Registro", "type": "link" },
                { "path": "/analista/buscarEmpresas", "title": "Empresas", "type": "link" },
                { "path": "/analista/buscarPersonaEmpresa", "title": "Buscar Usuario Empresa", "type": "link" },
                { "path": "/analista/buscarExtranjero", "title": "Buscar Extranjero", "type": "link" },
                { "path": "/analista/buscarExtranjeroSicof", "title": "Buscar Extranjero Sicof", "type": "link" },
                { "path": "/analista/analisisSeguimiento", "title": "Análisis y Seguimiento", "type": "link" }
              ]
            }
          ];
          break;
        case 3:
          state.data = [
            {
              "title": "EMPRESA", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "2", "active": true,
              "children": [
                { "path": "/empresa/Empresas", "title": "Empresa", "type": "link" },
                // { "path": "/empresa/ReporteTotalEmpresa", "title": "Reportes por Empresa", "type": "link" },
                { "path": "/empresa/Reportes", "title": "Reportes", "type": "link" }
              ]
            }
          ];
          break;
        case 4:
          state.data = [
            {
              "title": "PERSONA", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "2", "active": true,
              "children": [
                { "path": "/extranjero/historialdeclaracion", "title": "Historial de Declaración", "type": "link" },
                { "path": "/extranjero/declaracion", "title": "Declaración", "type": "link" },
                //{ "path": "/extranjero/DeclaracionHijos", "title": "Declaración Menores", "type": "link" }
              ]
            }
          ];
          break;
        case 5:
          state.data = [
            {
              "title": "OPERADOR", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "4", "active": true,
              "children": [
                { "path": "/analista/buscarPersona", "title": "Lista de Registros", "type": "link" },
                { "path": "/analista/frmPersona", "title": "Nuevo Registro", "type": "link" },
                { "path": "/analista/ReporteDiario", "title": "Parte Diario", "type": "link" },
                { "path": "/analista/ReportePorOperador", "title": "Reporte", "type": "link" }
              ]
            }
          ];
          break;
        // case 6:
        //   state.data = [
        //     {
        //       "title": "AUTOMATIZADO", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "1", "active": true,
        //       "children": [
        //         { "path": "/automatizado/Vuelos", "title": "Vuelos", "type": "link" },
        //         { "path": "/automatizado/listaRobot", "title": "Listado", "type": "link" },
        //         { "path": "/robot/FormularioError", "title": "Formulario Robot", "type": "link" },
        //         /*{ "path": "/automatizado/Equipos", "title": "Equipos", "type": "link" },
        //         { "path": "/automatizado/ReporteVuelos", "title": "Reportes", "type": "link" }*/
        //       ]
        //     }
        //   ];
        //   break;
        case 7:
          state.data = [
            {
              "title": "REPORTES", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "3", "active": true,
              "children": [
                { "path": "/reporte/reporteEmpresa", "title": "Reporte de Empresas", "type": "link" },
                { "path": "/reporte/reporteAereo", "title": "Reporte Aereo", "type": "link" },
                { "path": "/reporte/reporteHotel", "title": "Reporte Hotel", "type": "link" }
              ]
            }
          ];
          break;
          case 8:
            state.data = [
        {
          "title": "OPERADOR VENT.", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "1", "active": true,
          "children": [
            //{ "path": "/ventanilla/analisisSeguimientoVentanilla", "title": "Personas Multadas", "type": "link" }
            { "path": "/analista/buscarPersona", "title": "Lista de Registros", "type": "link" },
            { "path": "/analista/frmPersona", "title": "Nuevo Registro", "type": "link" },
            { "path": "/analista/ReporteDiario", "title": "Parte Diario", "type": "link" },
            { "path": "/analista/ReportePorOperador", "title": "Reporte", "type": "link" }
          ]
        }
      ];
      break;
      case 11:
        state.data = [
    {
      "title": "VERICACIÓN", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "1", "active": true,
      "children": [
        //{ "path": "/ventanilla/analisisSeguimientoVentanilla", "title": "Personas Multadas", "type": "link" }
        { "path": "/verificacion/Verificar", "title": "Busqueda de Trámites", "type": "link" }
      
      ]
    }
  ];
  break;
        default:
          state.data = []
          break;
      }
    }
  }
};

// actions
const actions = {
  opensidebar: (context, term) => {
    context.commit('opensidebar', term)
  },
  resizetoggle: (context, term) => {
    context.commit('resizetoggle', term)
  },
  searchTerm: (context, term) => {
    context.commit('searchTerm', term)
  },
  setNavActive: (context, item) => {
    context.commit('setNavActive', item)
  },
  setActiveRoute: (context, item) => {
    context.commit('setActiveRoute', item)
  },
  generarMenu: (context, item) => {
    context.commit('generarMenu', item)
  }
}



export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}






